// extracted by mini-css-extract-plugin
var _1 = "hOtchBjrz37VbhJLamYL";
var _2 = "JI0kb2GW2oMIegW2N65i";
var _3 = "IiOxz11a7gN31J_bFifs";
var _4 = "F7jZls2tA_aDwlGWS2h9";
var _5 = "m86XFyYRsAUCPNMezuFh";
export { _1 as "bgimg", _2 as "fullscreenButton", _3 as "subnav", _4 as "subnavholder", _5 as "title" }
